import React, { } from 'react';
import { getTableDisplayName, TDR } from 'tdr-common';
import { useViewToggle } from '../../context/ViewToggleProvider';
import { useScreenSize } from '../../hooks/useScreenSize';
import ArrowRight from '../../icons/right-icon.svg';
import TableInfo from '../table-drawer/TableInfo';
import { ProximityInfoContainer } from './ProximityInfoContainer';
import useNavigateWIthQuery from '../../hooks/useNavigateWIthQuery';
import { analytics } from '../../helpers/analytics/analytics';
type ClosestTableInfoProps = {
	table: TDR.Table;
	onClick: (table: TDR.Table) => void;
	availableTables: TDR.Table[];
};
export const ClosestTableInfo: React.FC<ClosestTableInfoProps> = ({ table, onClick, availableTables }) => {

	const navigateWIthQuery = useNavigateWIthQuery();
	const { isVirtualView, turnOffVirtualView } = useViewToggle();
	const { isSmallScreen } = useScreenSize();
	const displayName = getTableDisplayName(table);
	const availableTable = availableTables?.some(availableTable => availableTable.id === table.id);
	return (
		<ProximityInfoContainer
			availableTable={availableTable}
			title={displayName}
			body={<TableInfo minGuests={table.minGuests} maxGuests={table.maxGuests} />}
			icon={ArrowRight}
			replaceIconWithLabel={isVirtualView || isSmallScreen}
			onClick={() => {
				onClick(table);
				turnOffVirtualView();
				navigateWIthQuery(`explore/${table.slug}`);
				analytics.track('Matterport Link Clicked', {
					link: `explore/${table.slug}`,
					title: 'Closest Table'
				});
			}}
		/>
	);
};
